"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HiddenScroll = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const styled_1 = require("./styled");
const removeChildContainer = (element) => document.body.contains(element) && document.body.removeChild(element);
const getScrollbarWidth = () => {
    const scrollDiv = document.createElement('div');
    scrollDiv.style.width = '99px';
    scrollDiv.style.height = '99px';
    scrollDiv.style.position = 'absolute';
    scrollDiv.style.top = '-9999px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    const width = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    removeChildContainer(scrollDiv);
    return width;
};
const useScrollbarWidth = () => {
    const [scrollbarWidth, setScrollbarWidth] = (0, react_1.useState)();
    (0, react_1.useEffect)(() => {
        setScrollbarWidth(getScrollbarWidth());
    }, []);
    return scrollbarWidth;
};
exports.HiddenScroll = (0, react_1.forwardRef)((props, ref) => {
    const scrollbarWidth = useScrollbarWidth();
    if (typeof scrollbarWidth === 'undefined')
        return null;
    const { children } = props, otherProps = __rest(props, ["children"]);
    return ((0, jsx_runtime_1.jsx)(styled_1.OverflownParent, Object.assign({ ref: ref }, otherProps, { children: (0, jsx_runtime_1.jsx)(styled_1.HiddenScrollbar, { scrollbarWidth, children: children }) })));
});
exports.HiddenScroll.displayName = 'HiddenScroll';
exports.default = exports.HiddenScroll;
